export let GlobalStyleClasses = /*#__PURE__*/function (GlobalStyleClasses) {
  GlobalStyleClasses["sapScrollBar"] = "sapScrollBar";
  GlobalStyleClasses["inheritingSapScrollBar"] = "inheritingSapScrollBar";
  return GlobalStyleClasses;
}({});